import { parse, isValid } from 'date-fns';

/**
 * Tries to parse the date string in multiple formats.
 * If the date string is not in any of the formats, it throws an error.
 * Why we need this function?
 * I noticed that the date string returned by the API is not consistent. It varies depending on whether or not I'm using dev or prod.
 * Ideally, the API should return the date in a consistent format. I couldn't figure out why it's not consistent.
 * So, I wrote this function to handle the inconsistency.
 * @param dateString
 * @returns
 */
export function customDateParser(dateString: string) {
	let date;
	// Try parsing as ISO format (YYYY-MM-DD)
	date = parse(dateString, 'yyyy-MM-dd hh:mm:ss aa', new Date());
	if (isValid(date)) {
		return date;
	}

	// Try parsing as US format (MM/DD/YYYY)
	date = parse(dateString, 'M/d/yyyy h:mm:ss a', new Date());
	if (isValid(date)) {
		return date;
	}

	throw new Error('API returned invalid date format');
}

